export default "__VITE_ASSET__67142a7b__"